import React from 'react';
import { Container, Typography, Grid } from '@mui/material';

const SecondFooter = ({ position = '' }) => {
  return (
    <Grid className="second-footer" container>
      <Grid size={12} align="center">
        <Typography color="textSecondary">
          © {new Date().getFullYear()} OneService
        </Typography>
      </Grid>
    </Grid>
  )
}

export default SecondFooter;
